<template>
  <div>
    <!--General Top Bar -->
    <!-- <general-top-bar :title="$t('reports.trends')"></general-top-bar> -->
    <!--End General Top Bar -->
    <div class="trends-report">
      <div class="row">
        <div class="col-md-12">
          <div class="pull-left mar-rt-10" v-if="showLocations">
            <span class="pad-rg-5">{{$t('dashboard.selectLocation')}}</span>
            <select
              class="form-control inline-auto white"
              v-model="trends.location"
            >
              <option value selected :label="$t('general.all')">{{$t('general.all')}}</option>
              <template v-for="(loc, key) in locations">
                <option :label="loc.name" :value="loc.id" :key="loc.id + key">{{loc.name}}</option>
              </template>
            </select>
          </div>
          <p class="pull-left">
            <el-date-picker
              type="daterange"
              v-model="trends.valid"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              :name="pickerNames"
              :picker-options="pickerOptions"
            ></el-date-picker>
          </p>
          <div class="pull-left search-button-reports">
            <div class="btn btn-icon btn-search" :title="$t('reports.search')" @click="updateData"><i class="ti-search"></i></div>
          </div>
        </div>
      </div>
      <div class="row text-left">
        <!-- Orders Chart -->
        <div class="col-md-12">
          <chart-card
            v-loading="loading"
            :chart-data="ordersChart.data"
            :chart-options="ordersChart.options"
            ref="refOrdersChart"
          >
            <div slot="header">
              <h4 class="card-title">{{$t('reports.orderChart')}}</h4>
              <p class="category">{{ordersChart.title}}</p>
            </div>
            <div slot="footer">
              <div class="chart-legend">
                <i class="fa fa-circle text-info"></i>
                {{$t('dashboard.completed')}}
              </div>
            </div>
          </chart-card>
        </div>
        <!-- Sales chart -->
        <div class="col-md-12">
          <chart-card
            v-loading="loading"
            :chart-data="salesChart.data"
            :chart-options="salesChart.options"
            ref="salesChart"
          >
            <div slot="header">
              <h4 class="card-title">{{$t('reports.salesChart')}}</h4>
              <p class="category">{{salesChart.title}}</p>
            </div>
            <div slot="footer">
              <div class="chart-legend">
                <i class="fa fa-circle text-info"></i>
                {{$t('reports.salesIn')}} {{currency}}
              </div>
            </div>
          </chart-card>
        </div>
      </div>
      <div class="row text-left">
        <div class="col-md-12" v-if="!this.trends.location">
          <chart-card
            v-loading="loading"
            :chart-data="customersChart.data"
            :chart-options="customersChart.options"
            ref="customersChart"
          >
            <div slot="header">
              <h4 class="card-title">{{$t('reports.newCustomersChart')}}</h4>
              <p class="category">{{customersChart.title}}</p>
            </div>
            <div slot="footer">
              <div class="chart-legend">
                <i class="fa fa-circle text-info"></i>
                {{$t('reports.custWithAcc')}}
              </div>
            </div>
          </chart-card>
        </div>

        <div class="col-md-12 chart-bar-label">
          <chart-bars-card
            v-loading="loading"
            :chart-data="topProdsChart.data"
            :chart-options="topProdsChart.options"
            ref="topProdsChart"
          >
            <div slot="header">
              <h4 class="card-title">{{$t('reports.top10Chart')}}</h4>
              <p class="category">{{topProdsChart.title}}</p>
            </div>
            <div slot="footer">
              <div class="chart-legend">
                <i class="fa fa-circle text-info"></i>
                {{$t('reports.salesProductNr')}}
              </div>
            </div>
          </chart-bars-card>
        </div>

        <div class="col-md-6 delivery-height">
          <chart-bars-card
            v-loading="loading"
            :chart-data="deliveryChart.data"
            :chart-options="deliveryChart.options"
            ref="deliveryChart"
          >
            <div slot="header">
              <h4 class="card-title">{{$t('reports.orderingChart')}}</h4>
              <p class="category">{{deliveryChart.title}}</p>
            </div>
            <div slot="footer">
              <div class="chart-legend">
                <i class="fa fa-circle text-info"></i>
                {{$t('reports.nrOfOrders')}}
              </div>
            </div>
          </chart-bars-card>
        </div>

        <div class="col-md-6 delivery-height">
          <chart-pie-card 
            v-loading="loading"
            :chart-data="paymentsChart.data"
            :chart-options="paymentsChart.options"
            ref="paymentsChart"
          >
            <div slot="header">
              <h4 class="card-title">{{$t('reports.cash')}} VS {{$t('reports.card')}}</h4>
              <p class="category">{{paymentsChart.title}}</p>
            </div>
            <div slot="footer">
              <div class="chart-legend">
              </div>
            </div>
          </chart-pie-card>
        </div>

      </div>

      <div class="row text-left" v-if="!trends.location">
        <div class="col-md-6 pie-height">
          <chart-pie-card
            v-loading="loading"
            :chart-data="ageChart.data"
            :chart-options="ageChart.options"
            ref="ageChart"
          >
            <div slot="header">
              <h4 class="card-title">{{$t('reports.customersAge')}}</h4>
              <p class="category">{{ageChart.title}}</p>
            </div>
            <div slot="footer">
              <div class="chart-legend">
                <p></p>
              </div>
            </div>
          </chart-pie-card>
        </div>
        <div class="col-md-6 pie-height">
          <chart-pie-card
            v-loading="loading"
            :chart-data="genderChart.data"
            :chart-options="genderChart.options"
            ref="genderChart"
          >
            <div slot="header">
              <h4 class="card-title">{{$t('reports.customersGender')}}</h4>
              <p class="category">{{genderChart.title}}</p>
            </div>
            <div slot="footer">
              <div class="chart-legend">
                <p></p>
              </div>
            </div>
          </chart-pie-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {DatePicker} from 'element-ui'
import ChartCard from 'src/components/UIComponents/Cards/ChartCard.vue'
import ChartBarsCard from 'src/components/UIComponents/Cards/ChartBarsCard.vue'
import ChartPieCard from 'src/components/UIComponents/Cards/ChartPieCard.vue'
// import GeneralTopBar from 'src/components/UIComponents/Inputs/generalTopBar.vue'
import moment from 'moment'

export default {
  components: {
    // GeneralTopBar,
    [DatePicker.name]: DatePicker,
    ChartCard,
    ChartBarsCard,
    ChartPieCard
  },
  props: {
    isTrends: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    isTrends () {
      if (this.isTrends) {
        this.getTrends()
      }
    }
  },
  data () {
    return {
      loading: false,
      trends: {
        valid: [
          moment()
            .date(1)
            .format('YYYY-MM-DD'),
          moment()
            .endOf('month')
            .format('YYYY-MM-DD')
        ],
        location: ''
      },
      showLocations: false,
      currency: this.getCurrencySymbol(this.$session.get('selectedCompanyData')['currency_iso']),
      pickerOptions: {
        disabledDate (date) {
          return date < moment().subtract(12, 'months').startOf('day')
        }
      },
      pickerNames: ['date_from', 'date_to'],
      locations: [],
      ordersChart: {
        title: '',
        data: {
          labels: [],
          series: []
        },
        options: {
          seriesBarDistance: 10,
          axisX: {
            showGrid: false
          },
          axisY: {
            onlyInteger: true
          },
          height: '200px'
        }
      },
      customersChart: {
        title: '',
        data: {
          labels: [],
          series: []
        },
        options: {
          seriesBarDistance: 10,
          axisX: {
            showGrid: false
          },
          axisY: {
            onlyInteger: true
          },
          height: '200px'
        }
      },
      salesChart: {
        title: '',
        data: {
          labels: [],
          series: []
        },
        options: {
          showArea: true,
          height: '200px',
          axisX: {
            showGrid: false
          },
          showLine: true
        }
      },
      topProdsChart: {
        title: '',
        data: {
          labels: [],
          series: []
        },
        options: {
          seriesBarDistance: 20,
          showArea: true,
          height: '300px',
          axisX: {
            scaleMinSpace: 30,
            showGrid: false
          },
          axisY: {
            onlyInteger: true
          }
        }
      },
      deliveryChart: {
        title: '',
        data: {
          labels: [],
          series: []
        },
        options: {
          seriesBarDistance: 10,
          showArea: true,
          height: '300px',
          axisX: {
            showGrid: false
          },
          axisY: {
            onlyInteger: true
          }
        }
      },
      paymentsChart: {
        title: '',
        data: {
          labels: [],
          series: []
        },
        options: {
          showArea: true,
          height: '300px',
          width: '300px'
        }
      },
      ageChart: {
        title: '',
        data: {
          labels: [],
          series: []
        },
        options: {
          showArea: true,
          height: '300px'
        }
      },
      genderChart: {
        title: '',
        data: {
          labels: [],
          series: []
        },
        options: {
          showArea: true,
          height: '300px'
        }
      }
    }
  },
  created () {
    this.verifyUserLocations()
  },
  methods: {
    verifyUserLocations () {
      this.locations = this.$session.get('selectedCompanyData').locations_details
      if (!this.isOwner()) {
        const allowedLocations = JSON.parse(this.$session.get('userDataLocations'))
        if (allowedLocations.length === 0) {
          this.showLocations = true
          this.locations.forEach((element) => {
            allowedLocations.push(element.id)
          })
        }
        this.locations = this.locations.filter(el => {
          return allowedLocations.includes(el.id)
        })
      }
      if (this.locations.length > 1) {
        this.showLocations = true
        let filterCookie = this.$cookie.get('filter-locations')
        if (filterCookie) {
          filterCookie = JSON.parse(filterCookie)
          this.trends.location = filterCookie[0]
        }
      }
    },
    getTrends () {
      if (!this.isTrends) {
        return
      }
      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        start_date: this.trends.valid[0],
        end_date: this.trends.valid[1]
      }
      if (this.trends.location && this.trends.location !== '') {
        data.location_id = this.trends.location
      }
      this.loading = true
      const ver = this.$route.query && this.$route.query.ver === 'V2' ? 'V2' : ''
      this.apiRequest('/reports/trends' + ver, 'GET', data, response => {
        if (response.status === true) {
          this.ordersChart.data.labels = response.data.orders.labels
          this.ordersChart.data.series = [response.data.orders.delivered]
          this.ordersChart.title = this.$t('reports.total') + ' ' + response.data.counters.total_orders
          // this.ordersChart.data.canceled = response.data.orders.canceled
          // this.ordersChart.data.delivered = response.data.orders.delivered
          this.$refs.refOrdersChart.initChart()

          this.customersChart.data.labels = response.data.customers.labels
          this.customersChart.data.series = [response.data.customers.values]
          this.customersChart.title = this.$t('reports.total') + ' ' + response.data.counters.customers
          if (this.$refs.customersChart) {
            this.$refs.customersChart.initChart()
          }

          this.salesChart.data.labels = response.data.sales.labels
          this.salesChart.data.series = [response.data.sales.values]
          this.salesChart.title = this.$t('reports.total') + ' ' + response.data.counters.revenue
          this.$refs.salesChart.initChart()

          this.topProdsChart.data.labels = response.data.top_products['labels']
          this.topProdsChart.data.series = [response.data.top_products['values']]
          this.$refs.topProdsChart.initChart()

          this.deliveryChart.data.labels = response.data.delivery_types.labels
          this.deliveryChart.data.series = [response.data.delivery_types.values]
          this.$refs.deliveryChart.initChart()

          let customersAgeLb = []
          if (response.data.customers_age.labels.length) {
            customersAgeLb = response.data.customers_age.labels.map((val, key) => {
              val = this.$t('reportsAgesGroups.' + val) + ' - ' + parseFloat(response.data.customers_age.series[key] * 100 / response.data.counters.customers).toFixed(2) + '%'
              return val
            })
          }
          this.ageChart.data.labels = customersAgeLb
          this.ageChart.data.series = response.data.customers_age.series
          if (response.data.customers_age.labels.length) {
            this.$refs.ageChart.initChart()
          }

          let customersGenderLb = []
          if (response.data.customers_gender.labels.length) {
            customersGenderLb = response.data.customers_gender.labels.map((val, key) => {
              val = this.$t('gender.' + val) + ' - ' + parseFloat(response.data.customers_gender.series[key] * 100 / response.data.counters.customers).toFixed(2) + '%'
              return val
            })
          }
          this.genderChart.data.labels = customersGenderLb
          this.genderChart.data.series = response.data.customers_gender.series
          if (response.data.customers_gender.labels.length) {
            this.$refs.genderChart.initChart()
          }
          let totalPayments = response.data.payments.card + response.data.payments.cash
          if (totalPayments) {
            this.paymentsChart.data.labels = [
              this.$t('reports.card') + ' - ' + parseFloat(response.data.payments.card * 100 / totalPayments).toFixed(2) + '%',
              this.$t('reports.cash') + ' - ' + parseFloat(response.data.payments.cash * 100 / totalPayments).toFixed(2) + '%'
            ]
            this.paymentsChart.data.series = [
              {
                value: response.data.payments.card,
                name: this.$t('reports.card')
              },
              {
                value: response.data.payments.cash,
                name: this.$t('reports.cash')
              }
            ]
            this.$refs.paymentsChart.initChart()
          }

          this.$nextTick(() => {
            this.loading = false
          })
        }
      })
    },
    updateData () {
      this.getTrends()
      this.$nextTick(() => {
        this.loading = false
      })
      this.$cookie.set('filter-locations', JSON.stringify([this.trends.location]), 30)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Reports/Trends.vue